import { Component, Input, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
// Deep-Import statt @core-Barrel: der Barrel zieht sonst ./guards (login.guard) mit,
// was ueber DialogService einen zirkulaeren Import (TDZ, NG0203) verursacht und die Testsuite blockiert.
import { AuthService } from '@core/authentication/auth.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'error-code',
  templateUrl: './error-code.component.html',
  styleUrls: ['./error-code.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MatButtonModule, RouterModule, TranslateModule],
})
export class ErrorCodeComponent {
  @Input() code = '';

  @Input() message = '';

  @Input() showHomeButton = true;

  @Input() showLogoutButton = false;

  @Input() title = '';

  constructor(private authService: AuthService) {}

  public logout(): void {
    this.authService.logout();
  }
}
